<cigna-omni-fancy-invitation
  *ngIf="fancyInvitationConv$ | async"
  [conv]="fancyInvitationConv$ | async"
  (dismiss)="handleDismissEvent($event)"
  (viewed)="handleViewedEvent()"
  (openConv)="handleOpenConvEvent($event)"
></cigna-omni-fancy-invitation>
